import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../../store/slices/auth-slice";
import { useAppSelector } from "../../../../../hooks/app";
import { ROLES } from "../../../../../constants";

function SoloCrossCountryTwo({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [planning, setPlanning] = React.useState("");
  const [flightFrom, setFlightFrom] = React.useState("");
  const [flightTo, setFlightTo] = React.useState("");
  const [flightVia, setFlightVia] = React.useState("");
  const [landings, setLandings] = React.useState("");
  const [aircraftType, setAircraftType] = React.useState("");
  const [date, setDate] = React.useState("");
  const [limitation, setLimitation] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I have reviewed the cross-country planning of ${planning} preparation and find the planning and preparation to be correct to make the solo flight from ${flightFrom} to ${flightTo} via ${flightVia} with ${landings} landings in a ${aircraftType} aircraft on ${date}. Limitations §61.89(a)(8): ${limitation}`;
    dispatch(setTemplateText(templateText));
  }, [planning, flightFrom, flightTo, flightVia, landings, aircraftType, date, limitation, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 61.107(b)</label>
      </div>
      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I have reviewed the cross-country planning of
          <input type="text" onChange={(e) => setPlanning(e.target.value)} value={planning} /> I find the planning and preparation to be correct to make the solo flight from <input
            type="text"
            onChange={(e) => setFlightFrom(e.target.value)}
            style={{ margin: '0 5px' }}
          /> to <input
            type="text"
            onChange={(e) => setFlightTo(e.target.value)}
            style={{ margin: '0 5px' }}
          /> via <input
            type="text"
            onChange={(e) => setFlightVia(e.target.value)}
            style={{ margin: '0 5px' }}
          /> with landings  <input
            type="text"
            onChange={(e) => setLandings(e.target.value)}
            style={{ margin: '0 5px' }}
          /> in a <input
            type="text"
            onChange={(e) => setAircraftType(e.target.value)}
            style={{ margin: '0 5px' }}
          /> aircraft on <input
            type="text"
            onChange={(e) => setDate(e.target.value)}
            style={{ margin: '0 5px' }}
          /> Limitations §61.89(a)(8): <input
            type="text"
            onChange={(e) => setLimitation(e.target.value)}
            style={{ margin: '0 5px' }}
          />
        </p>
      </div>
    </TemplateLayout>
  );
}

export default SoloCrossCountryTwo;
